export default __webpack_public_path__ + "static/media/design3.0d0e489b.png";